import { render, staticRenderFns } from "./ReportFieldColorSelect.vue?vue&type=template&id=27c6176e"
import script from "./ReportFieldColorSelect.vue?vue&type=script&lang=js"
export * from "./ReportFieldColorSelect.vue?vue&type=script&lang=js"
import style0 from "./ReportFieldColorSelect.vue?vue&type=style&index=0&id=27c6176e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports